import React from 'react';
import Icon from '../../../components/AppIcon';

const BlogHero = () => {
  return (
    <section className="bg-background pt-20 pb-12 lg:pt-28 lg:pb-16 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-accent/10 opacity-50"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="bg-accent/10 p-2.5 rounded-full">
              <Icon name="Satellite" size={28} className="text-accent" />
            </div>
          </div>
          
          <h1 className="font-heading text-3xl lg:text-4xl xl:text-5xl font-bold text-text-primary mb-4">
            Explorations in{" "}
            <span className="text-accent block mt-1">Space, AI & Innovation</span>
          </h1>
          
          <p className="font-body text-base lg:text-lg text-text-secondary max-w-3xl mx-auto mb-6 leading-relaxed">
            Insights from my journey with ISRO, NASA STEM, and real-world projects. 
            From atmospheric science to AI, explore technical blogs, research takeaways, and career guidance.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <div className="flex items-center gap-2 text-text-secondary">
              <Icon name="Rocket" size={20} />
              <span className="font-body text-sm">ISRO & NASA Experiences</span>
            </div>
            <div className="flex items-center gap-2 text-text-secondary">
              <Icon name="Code2" size={20} />
              <span className="font-body text-sm">AI, Remote Sensing, Dev</span>
            </div>
            <div className="flex items-center gap-2 text-text-secondary">
              <Icon name="Lightbulb" size={20} />
              <span className="font-body text-sm">Student Research Advice</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
